import MediaCard from '@/components/feature/MediaCard';
import type { Media } from '@/types/media';

interface MediaGridProps {
  items: Media[];
  columns?: string;
}

export default function MediaGrid({ items, columns = 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6' }: MediaGridProps) {
  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg bg-background-100 py-16 text-center">
        <i className="ri-inbox-archive-line text-4xl text-foreground-300" />
        <p className="mt-3 text-sm text-foreground-500">暂无相关内容，建议刷新或查看其他分类</p>
      </div>
    );
  }

  return (
    <div className={`grid gap-3 md:gap-4 ${columns}`} data-product-shop>
      {items.map((item) => (
        <MediaCard key={item.id} item={item} />
      ))}
    </div>
  );
}